import React from 'react'
import CreditScore from 'Src/components/desking-page/CreditScore/CreditScore'
import DownPayment from 'Src/components/desking-page/DownPayment/DownPayment'
import FinanceTerms from 'Src/components/desking-page/Terms/FinanceTerms'
import TermsHeader from 'Src/components/desking-page/Terms/TermsHeader'
import ZipCode from 'Src/components/desking-page/ZipCode/ZipCode'
import {CTA_TYPES} from 'Src/constants'
import {useCustomerStateContext} from 'Src/contexts/CustomerContext'
import {useDealStateContext} from 'Src/contexts/DealContext'
import useConfig from 'Src/utilities/useConfig'

const Finance = () => {
  const {loading, data, retailDownPayment, zipCode, retailDownPaymentIncrements} =
    useDealStateContext()
  const {customerData} = useCustomerStateContext()
  const {ctaType} = useConfig()
  const finance = data.attributes?.dealTypes?.finance
  const terms = finance?.programs?.termsGroup
  const isSoftPullExperience =
    ctaType === CTA_TYPES.SOFT_PULL && !!customerData.softPullCreditReport

  return loading ? (
    <div data-testid="loading" />
  ) : (
    <div>
      <DownPayment
        downPayment={retailDownPayment}
        downPaymentIncrements={retailDownPaymentIncrements}
      />
      {zipCode ? <ZipCode /> : null}
      {!isSoftPullExperience ? (
        <>
          <div className="divider tw-my-12" />
          <CreditScore />
        </>
      ) : null}
      <div className="divider tw-my-12" />
      {terms ? (
        <div role="group" aria-labelledby="payment-term">
          <TermsHeader data-testid="terms-header" />
          <FinanceTerms terms={terms} data-testid="finance-terms" />
        </div>
      ) : null}
    </div>
  )
}

export default Finance
